<app-dashboard-header></app-dashboard-header>
<!-- Dashboard -->
<div *ngIf="requests != null"
    class="container-fuid ms-2 ms-sm-2 ms-md-4 ms-lg-5 ms-xl-5 ms-xxl-5 me-2 me-sm-2 me-md-4 me-lg-5 me-xl-5 me-xxl-5 default-boxshadow mt-4 bg-white default-boxrounded p-0">
    <div>
        <app-dashboardfilter #operations [requests]="requests!"
            (workgroup)="updateWorkgroupVisibility($event)" (filterChanged)="activities.filter = $event"
            (actionSelected)="performBulkAction($event)"></app-dashboardfilter>

        <app-request-table #activities [requests]="requests"
            [workgroup]="workgroup" (selectionChanged)="this.operations.selectedRequests = $event">
        </app-request-table>
    </div>
</div>